module.exports = __webpack_public_path__ + "img/router-2.01a6681f.webp";